import { Grid } from '@mui/material';
import { Page } from '../../components/Page/Page';
import { Category, fetchCategories } from '../../api/blogs';
import { Section } from '../../components/Section/Section';
import { CategoryCard } from '../../components/Kennisbank/CategoryCard';
import { HighLightedText } from '../../components/HighLightedText/HighLightedText';
import React from 'react';

interface Props {
  categories: Category[];
}

export default function KennisbankPage(props: Props) {
  const { categories } = props;
  return (
    <Page
      title={'Doe kennis en inspiratie op in onze kennisbank.'}
      seo={{
        description:
          'Inspiratie nodig over hoe je op andere manieren onze producten succesvol kunt inzetten bij jouw organisatie of uitleg nodig over een bepaalde functionaliteit? Je vindt het in onze kennisbank.',
        openGraph: {
          type: 'website',
          locale: 'nl_NL',
          title:
            'Doe kennis en inspiratie op in onze kennisbank. | AppCenter Nederland',
          description:
            'Inspiratie nodig over hoe je op andere manieren onze producten succesvol kunt inzetten bij jouw organisatie of uitleg nodig over een bepaalde functionaliteit? Je vindt het in onze kennisbank.',
          images: [
            {
              url: 'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/featured_img_home_v2.jpg',
              secureUrl:
                'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/featured_img_home_v2.jpg',
              width: 1920,
              height: 1080,
              alt: 'Inspiratie nodig over hoe je op andere manieren onze producten succesvol kunt inzetten bij jouw organisatie of uitleg nodig over een bepaalde functionaliteit? Je vindt het in onze kennisbank.',
              type: 'image/jpeg',
            },
          ],
          site_name: 'AppCenter Nederland',
        },
      }}
    >
      <Section1 categories={categories} />
    </Page>
  );
}

function Section1({ categories }: { categories: Category[] }) {
  return (
    <Section
      position={'center'}
      subtitle={
        'Inspiratie nodig over hoe je op andere manieren onze producten succesvol kunt inzetten bij jouw organisatie of uitleg nodig over een bepaalde functionaliteit? Je vindt het in onze kennisbank.'
      }
      caption={'Van handleidingen tot tips en tricks.'}
      title={
        <>
          Doe kennis en inspiratie op in onze{' '}
          <HighLightedText
            TypographyProps={{ color: 'secondary' }}
            text={'kennisbank.'}
          />
        </>
      }
    >
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {categories.map((category, key) => (
          <Grid item key={key} xs={12} sm={12} md={4} lg={4}>
            <CategoryCard category={category} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}

// This gets called on every request
export async function getStaticProps() {
  const categories = await fetchCategories();
  return {
    props: {
      categories,
    },
  };
}
